/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

export namespace AgentDetailsWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

const styles = StyleSheet.create({
  agentDetailsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: 5,
    fontSize: 15,
    lineHeight: '16px',
    wordBreak: 'break-all',
    alignItems: 'center',
    ':not(:last-child)': {
      marginBottom: 5,
    },
  },
});

export const AgentDetailsWrapper: React.FC<AgentDetailsWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <span className={css(styles.agentDetailsWrapper)} {...htmlProps}>
      {children}
    </span>
  );
};
